import * as React from "react";

const IconFile: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="currentColor"><path fill="currentColor" d="M8.25,4.5 L4.875,4.5 L4.5,4.5 L4.5,4.125 L4.5,0.75 L0.75,0.75 L0.75,11.25 L8.25,11.25 L8.25,4.5 Z M8.12578154,3.75 L5.25,0.874218464 L5.25,3.75 L8.12578154,3.75 Z M0.75,0 L5.4375,0 L9,3.5625 L9,11.25 L9,12 L8.25,12 L0.75,12 L0,12 L0,11.25 L0,0.75 L0,0 L0.75,0 Z"  transform="translate(0 .5)"/></svg>;
};

export default React.memo(IconFile);
